import { motion } from 'framer-motion'

const TipsPhoneMockup = () => {
  return (
    <div className="relative">
      <div className="w-80 h-[640px] bg-gray-900 rounded-[3rem] p-3 shadow-2xl border-2 border-gray-700">
        <div className="w-full h-full bg-black rounded-[2.5rem] overflow-hidden border border-gray-800">
          <motion.div 
            className="p-5"
            animate={{ y: [0, -250, 0] }}
            transition={{ duration: 8, repeat: Infinity, ease: "easeInOut", repeatDelay: 2 }}
          >
            {/* Status Bar */}
            <div className="flex justify-between items-center mb-6 text-sm font-semibold text-white">
              <span>9:41</span>
              <div className="flex gap-1">
                <div className="w-4 h-3 bg-gray-600 rounded-sm"></div>
                <div className="w-4 h-3 bg-gray-600 rounded-sm"></div>
                <div className="w-4 h-3 bg-gray-600 rounded-sm"></div>
              </div>
            </div>

            {/* Header */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="mb-6"
            >
              <div className="flex items-center gap-2 mb-2">
                <motion.span 
                  animate={{ scale: [1, 1.2, 1] }}
                  transition={{ delay: 0.5, duration: 0.5 }}
                  className="text-2xl"
                >
                  💡
                </motion.span>
                <div className="text-xl font-bold text-white">Azrefy Empfehlung</div>
              </div>
              <div className="text-xs text-gray-400">Personalisierte Spartipps für dich</div>
            </motion.div>

            {/* Tips Cards */}
            <div className="space-y-3">
              {/* Netflix Tip */}
              <motion.div 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4, duration: 0.5 }}
                className="bg-gradient-to-r from-red-50 to-pink-50 rounded-2xl p-4 border border-red-200"
              >
                <div className="flex items-start gap-3">
                  <div className="text-2xl flex-shrink-0">📺</div>
                  <div className="flex-1">
                    <div className="text-sm font-bold text-gray-900 mb-1">
                      Netflix Premium kündigen?
                    </div>
                    <div className="text-xs text-gray-600 mb-2">
                      Du nutzt nur 1 Stream. Spare €7.99/Monat mit Standard-Abo.
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="text-xs font-bold text-green-600">+€95/Jahr</div>
                      <button className="text-xs bg-white px-3 py-1 rounded-full font-semibold text-gray-700 border border-gray-300">
                        Details
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Electricity Contract */}
              <motion.div 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.6, duration: 0.5 }}
                className="bg-gradient-to-r from-yellow-50 to-amber-50 rounded-2xl p-4 border border-yellow-200"
              >
                <div className="flex items-start gap-3">
                  <div className="text-2xl flex-shrink-0">⚡</div>
                  <div className="flex-1">
                    <div className="text-sm font-bold text-gray-900 mb-1">
                      Stromvertrag wechseln
                    </div>
                    <div className="text-xs text-gray-600 mb-2">
                      Wir haben 3 günstigere Anbieter für dich gefunden.
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="text-xs font-bold text-green-600">+€234/Jahr</div>
                      <button className="text-xs bg-white px-3 py-1 rounded-full font-semibold text-gray-700 border border-gray-300">
                        Vergleichen
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Mobile Contract */}
              <motion.div 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.8, duration: 0.5 }}
                className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-4 border border-blue-200"
              >
                <div className="flex items-start gap-3">
                  <div className="text-2xl flex-shrink-0">📱</div>
                  <div className="flex-1">
                    <div className="text-sm font-bold text-gray-900 mb-1">
                      Neuer Handy-Vertrag
                    </div>
                    <div className="text-xs text-gray-600 mb-2">
                      Anpassbarer Tarif mit mehr Daten, weniger Kosten.
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="text-xs font-bold text-green-600">+€156/Jahr</div>
                      <button className="text-xs bg-white px-3 py-1 rounded-full font-semibold text-gray-700 border border-gray-300">
                        Tarife
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Tax Return - Featured */}
              <motion.div 
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1.0, duration: 0.5 }}
                className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-4 border-2 border-green-300 shadow-lg"
              >
                <div className="flex items-start gap-3">
                  <div className="text-2xl flex-shrink-0">📊</div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <div className="text-sm font-bold text-gray-900">
                        Steuererklärung Februar
                      </div>
                      <span className="text-xs bg-green-200 text-green-800 px-2 py-0.5 rounded-full font-bold">
                        NEU
                      </span>
                    </div>
                    <div className="text-xs text-gray-600 mb-2">
                      Deine Lohnsteuer ist bereit! Wir helfen dir Schritt für Schritt und holen Geld zurück.
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="text-xs font-bold text-green-600">~€943 Erstattung</div>
                      <button className="text-xs bg-green-600 text-white px-3 py-1.5 rounded-full font-semibold shadow">
                        Jetzt starten
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Gym Membership */}
              <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-4 border border-purple-200">
                <div className="flex items-start gap-3">
                  <div className="text-2xl flex-shrink-0">🏋️</div>
                  <div className="flex-1">
                    <div className="text-sm font-bold text-gray-900 mb-1">
                      Fitness-Abo ungenutzt
                    </div>
                    <div className="text-xs text-gray-600 mb-2">
                      Nur 2x im letzten Monat genutzt. Kündigen?
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="text-xs font-bold text-green-600">+€348/Jahr</div>
                      <button className="text-xs bg-white px-3 py-1 rounded-full font-semibold text-gray-700 border border-gray-300">
                        Analysieren
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Total Savings Summary */}
            <div className="mt-6 pt-4 border-t-2 border-gray-200">
              <div className="flex items-center justify-between bg-gradient-to-r from-primary to-secondary rounded-xl p-4 text-white shadow-lg">
                <div>
                  <div className="text-xs opacity-90">Gesamt-Sparpotenzial</div>
                  <div className="text-2xl font-bold">€1,776</div>
                  <div className="text-xs opacity-75">pro Jahr</div>
                </div>
                <div className="text-3xl">💰</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default TipsPhoneMockup
